export default [{
  path: 'dashboard',
  name: 'dashboardRoot',
  component: () => import(/* webpackChunkName: "dashboard" */ './Dashboard.vue'),
}];
